export default __webpack_public_path__ + "static/media/Becoming-Courier.bb843d55.png";